import {InspirationGridSection_Element} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation_page/sections.types';
import {
  COLORS,
  FONT_SIZES,
  GenericIconName,
  Icon,
  IconName,
  Text,
  UnstyledLinkLinaria,
  desktopAndUpLinaria,
  mediaTabletAndUp,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const InspirationGridSectionButton: React.FC<
  InspirationGridSection_Element & {
    className?: string;
    href?: string;
    onClick?: VoidFunction;
  }
> = ({className, type, href, onClick}) => {
  if (!type) {
    return null;
  }

  const {label, iconName} = getButtonContent(type);

  const ConditionalWrapper = href ? ConditionalLinkWrapper : SimpleWrapper;

  return (
    <ConditionalWrapper className={className} href={href} onClick={onClick}>
      <Label weight="mediumHeavy">{label}</Label>
      <IconWrapper>
        <Icon asset={iconName} size="SS" />
      </IconWrapper>
    </ConditionalWrapper>
  );
};

const ConditionalLinkWrapper: React.FC<
  React.PropsWithChildren<{href?: string; onClick?: VoidFunction}>
> = ({children, href, onClick}) => {
  return href ? (
    <LinkWrapper to={href} aria-label={undefined} onClick={onClick}>
      {children}
    </LinkWrapper>
  ) : (
    <>{children}</>
  );
};

const getButtonContent = (
  type: NonNullable<InspirationGridSection_Element['type']>,
): {label: string; iconName: IconName} => {
  switch (type.$case) {
    case 'liveShopping':
      return {
        label: type.liveShopping.headline,
        iconName: GenericIconName.PlayOutline,
      };
    case 'limitedDrops':
      return {
        label: type.limitedDrops.headline,
        iconName: GenericIconName.Clock,
      };
    case 'sneakerReleaseCalendar':
      return {
        label: type.sneakerReleaseCalendar.headline,
        iconName: GenericIconName.DropsSneaker,
      };
  }
};

const wrapperStyles = `
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background-color: ${COLORS['Fill.Grey.Primary']};
  padding: 12px 16px;

  > span {
    flex: 1;
  }

  @media ${mediaTabletAndUp} {
    border-radius: 0 0 8px 8px;
    min-height: 68px;
  }
`;

const LinkWrapper = styled(UnstyledLinkLinaria)`
  ${wrapperStyles}
`;

const SimpleWrapper = styled.div`
  ${wrapperStyles}
`;

const Label = styled(Text)`
  font-size: ${FONT_SIZES.px16};

  ${tabletAndUpLinaria(`
    font-size: ${FONT_SIZES.px12};
  `)}

  ${desktopAndUpLinaria(`
    font-size: ${FONT_SIZES.px16};
  `)}
`;

const IconWrapper = styled.div`
  width: 36px;
  height: 36px;
  background-color: ${COLORS.LiveShopping};
  border-radius: 100%;
  padding: 8px;
`;
